/**
 * 
 * @param {number} rating 
 * @param {number} maxRating 
 * @returns {"good" | "mixed" | "bad"}
 */
export const getStatusByRating = (rating, maxRating = 10) => {
    const third = maxRating/3;
    let status = 'good';
    if (rating < 2*third) {
        status = 'mixed';
    }
    if (rating < third) {
        status = 'bad';
    }
    return status;
}


// WEBPACK FOOTER //
// ./src/helpers/feedbacks.js